var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFootprint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.284,
    height: 45.872,
    viewBox: "0 0 27.284 45.872",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_156",
    "data-name": "Group 156",
    transform: "translate(0)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_154",
    "data-name": "Group 154",
    transform: "translate(16.678 16.726)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M1904.287,1931.737l6.741-1.164c0-.03-.006-.057-.007-.086-.1-1.207.066-1.444-.051-2.465-.158-1.368-.353-3.064-1.668-4a3.865,3.865,0,0,0-4.359.058c-1.616,1.143-1.519,3.314-1.488,4.2a19.247,19.247,0,0,0,.767,3.185C1904.243,1931.56,1904.268,1931.65,1904.287,1931.737Z",
    transform: "translate(-1903.442 -1923.382)",
    fill: "#d7cebc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M1875.621,2056.389a16.6,16.6,0,0,1-1.254-2.61,11.558,11.558,0,0,1-.436-1.689,1.535,1.535,0,0,1-.051-.146l-6.777,1.165c.005.063.014.125.019.188a10.382,10.382,0,0,1-.074,3.327c-.21.878-.567,1.274-.709,1.856a13.53,13.53,0,0,0,.1,6.367,9.158,9.158,0,0,0,2.682,4.848,3.232,3.232,0,0,0,1.987,1.022c1.65.045,2.986-1.858,3.454-2.8C1876.565,2063.866,1876.5,2058.768,1875.621,2056.389Z",
    transform: "translate(-1865.598 -2041.572)",
    fill: "#d7cebc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M2035.708,1813.279l-6.568-1.912c0-.03.012-.056.017-.085.23-1.189.1-1.442.328-2.444.31-1.342.694-3.005,2.105-3.783a3.864,3.864,0,0,1,4.325.546c1.478,1.317,1.138,3.464,1.008,4.338a19.238,19.238,0,0,1-1.12,3.079C2035.771,1813.108,2035.736,1813.195,2035.708,1813.279Z",
    transform: "translate(-2024.714 -1804.628)",
    fill: "#d7cebc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M2056.365,1930.588a16.653,16.653,0,0,0,1.539-2.453,11.585,11.585,0,0,0,.623-1.629c.023-.043.046-.089.067-.139l6.6,1.917c-.012.062-.028.123-.04.185a10.339,10.339,0,0,0-.3,3.315c.109.9.42,1.329.5,1.923a13.538,13.538,0,0,1-.809,6.316,9.159,9.159,0,0,1-3.21,4.516,3.233,3.233,0,0,1-2.088.793c-1.645-.14-2.758-2.182-3.118-3.169C2054.588,1937.912,2055.225,1932.853,2056.365,1930.588Z",
    transform: "translate(-2055.216 -1916.545)",
    fill: "#d7cebc"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootprint);
export default __webpack_public_path__ + "static/media/footprint.d42c07063ff937a6942e0225e2d47d91.svg";
export { ForwardRef as ReactComponent };